import axios from 'axios';

export const validateAccessCode = async (accessCode, token) => {
    const prodBaseUrl = process.env.NODE_ENV === 'production'
        ? 'https://api.mrreedsteamlab.com'
        : '';
    const endpoint = `${prodBaseUrl}/api/verify-access-code`;
    const body = { accessCode };
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
    };

    try {
        return await axios.post(endpoint, body, { headers });
    } catch (error) {
        throw new Error(
            'Error during access code validation:',
            error.response ? error.response.data : error.message,
        );
    }
};

export const validateSchoolLoginPassword = async (password) => {
    const prodBaseUrl = process.env.NODE_ENV === 'production'
        ? 'https://api.mrreedsteamlab.com'
        : '';
    const endpoint = `${prodBaseUrl}/api/verify-school-password`;
    const body = { password };
    const headers = {
        'Content-Type': 'application/json',
    };

    try {
        return await axios.post(endpoint, body, { headers });
    } catch (error) {
        if (error.response && error.response.data) {
            throw new Error(error.response.data);
        }
        throw new Error(error.response ? error.response.data : error.message);
    }
};
